import {
  CreateJobRequest,
  Job,
  jobCancelPath,
  jobPath,
  JOBS_PATH,
  jobSchema,
  ListJobsResponse,
  listJobsResponseSchema,
  SPEND_PATH,
  SpendResponse,
  spendResponseSchema,
} from '@quizdb/common';
import { quizdbApi } from '../api/quizdbApi';

/** The generation jobs' endpoints (QZ-D48, QZ-D55, QZ-D57). */
export const jobApi = quizdbApi.injectEndpoints({
  endpoints: (builder) => ({
    listJobs: builder.infiniteQuery<ListJobsResponse, void, string | undefined>({
      infiniteQueryOptions: {
        initialPageParam: undefined,
        getNextPageParam: (last) => last.nextCursor,
      },
      query: ({ pageParam }) => ({
        url: JOBS_PATH,
        params: pageParam === undefined ? {} : { cursor: pageParam },
      }),
      transformResponse: (response: unknown) => listJobsResponseSchema.parse(response),
      providesTags: ['JobList'],
    }),
    getJob: builder.query<Job, string>({
      query: (jobId) => jobPath(jobId),
      transformResponse: (response: unknown) => jobSchema.parse(response),
      providesTags: (_result, _error, jobId) => [{ type: 'Job', id: jobId }],
    }),
    createJob: builder.mutation<Job, CreateJobRequest>({
      query: (request) => ({ url: JOBS_PATH, method: 'POST', body: request }),
      transformResponse: (response: unknown) => jobSchema.parse(response),
      invalidatesTags: ['JobList', 'Spend'],
    }),
    cancelJob: builder.mutation<Job, string>({
      query: (jobId) => ({ url: jobCancelPath(jobId), method: 'POST' }),
      transformResponse: (response: unknown) => jobSchema.parse(response),
      invalidatesTags: (_result, _error, jobId) => [{ type: 'Job', id: jobId }, 'JobList'],
    }),
    getSpend: builder.query<SpendResponse, void>({
      query: () => SPEND_PATH,
      transformResponse: (response: unknown) => spendResponseSchema.parse(response),
      providesTags: ['Spend'],
    }),
  }),
});

export const {
  useListJobsInfiniteQuery,
  useGetJobQuery,
  useCreateJobMutation,
  useCancelJobMutation,
  useGetSpendQuery,
} = jobApi;
